import script from "./consultationDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./consultationDetail.vue?vue&type=script&setup=true&lang=js"

import "./consultationDetail.vue?vue&type=style&index=0&id=f16bde3c&lang=scss"

const __exports__ = script;

export default __exports__